/**
 * GSAP animation library initialization
 * Registers ScrollTrigger plugin and integrates with Lenis
 *
 * @package StandOut
 * @since 2.0.0
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);
// Integrate ScrollTrigger with Lenis smooth scrolling
window.addEventListener("lenis-ready", () => {
    const lenisInstance = window.lenis;
    if (lenisInstance) {
        lenisInstance.on("scroll", ScrollTrigger.update);
        gsap.ticker.add((time) => {
            lenisInstance.raf(time * 1000);
        });
        gsap.ticker.lagSmoothing(0);
    }
});
// Make GSAP plugins globally available
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
// Dispatch event for other scripts
const event = new CustomEvent("gsap-ready", { bubbles: true });
window.dispatchEvent(event);
